module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_CYSTERNA.0681d02a.svg";